import React, { useCallback } from 'react';
import DefaultContainer from '../../components/DefaultContainer';
import { Button, Text } from '~/components';
import { Components } from '~/scenes/HiredInsurance/components';
import useAppNavigation from '~/hooks/useAppNavigation';
import useToast from '~/hooks/useToast';

const HiredInsuranceCancelFailIncomeProtection: React.FC = () => {
  const { goBack, navigate } = useAppNavigation();
  const { showError } = useToast();

  const cancelContract = useCallback(async () => {
    const responseSuccess = true;

    if (responseSuccess) {
      navigate('MarisaServicos_HiredInsuranceCancelSuccessIncomeProtection');
    } else {
      showError({
        title: 'Ops!',
        description: 'Um erro ocorreu. Tente novamente.',
      });
    }
  }, [navigate, showError]);

  return (
    <DefaultContainer
      type="bag-protection"
      className="items-center justify-center py-10"
      showBanner={false}
    >
      <Text className="text-[22px] text-gray-600 text-center">
        Proteção Perda de Renda
      </Text>

      <Components.CancelStatus type="alert" />

      <Text className="text-lg text-gray-700 text-center mb-[22px]">
        Tivemos um problema no cancelamento. Tente novamente.
      </Text>

      <Text className="text-sm text-gray-400 mb-[38px] text-center">
        Ocorreu uma falha inesperada.
      </Text>

      <Button className="w-full mb-4" onPress={cancelContract}>
        Tente novamente
      </Button>

      <Button variant="tertiary" onPress={goBack}>
        VOLTAR
      </Button>
    </DefaultContainer>
  );
};

export default HiredInsuranceCancelFailIncomeProtection;
